/* app/js/src/components/tenant/choose-template/success-window/success-window.component.scss */
:host {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
div {
  font-size: 38px;
  margin: auto;
}
/*# sourceMappingURL=success-window.component.css.map */
